import { combineReducers } from "redux"
import userReducer from "./userReducer"
import productReducer from "./productReducer"
import projectReducer from "./projectReducer"
import modalReducer from "./modalReducer"
import modalRedeploymentReducer from "./modalRedeploymentReducer"
import companyReducer from "./companyReducer"
import userRoleReducer from "./userRoleReducer"
import activateProjectProcessReducer from "./activateProjectProcessReducer"
import controlPanelSidebarReducer from "./controlPanelSidebarReducer"
import participantReducer from "./participantReducer"
import controlPanelSelectedParticipantReducer from "./controlPanelSelectedParticipantReducer"
import userListReducer from "./userListReducer"
import archiveFilterReducer from "./archiveFilterReducer"
import drawerReducer from './drawerReducer'

const reducers = {
    userReducer,
    productReducer,
    projectReducer,
    modalReducer,
    modalRedeploymentReducer,
    companyReducer,
    userRoleReducer,
    activateProjectProcessReducer,
    controlPanelSidebarReducer,
    participantReducer,
    controlPanelSelectedParticipantReducer,
    userListReducer,
    archiveFilterReducer,
    drawerReducer
}
const reducer = combineReducers(reducers)
export default reducer
